
define('template!webshopAttributesSupplierValuesView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="toolbar">\n    <input type="text" class="search am-input" placeholder="' +
((__t = ( _.i18n('attributeMatching.searchSupplierValue', null, 'Search a supplier value') )) == null ? '' : __t) +
'"/>\n    <select class="supplier am-select">\n        <option value="">' +
((__t = ( _.i18n('attributeMatching.allSuppliers', null, 'All suppliers') )) == null ? '' : __t) +
'</option>\n        ';
 _.each(suppliers, function (s) { ;
__p += '<option value="' +
__e( s ) +
'">' +
__e( s ) +
'</option>';
 }); ;
__p += '\n    </select>\n    <label><input type="checkbox" class="unmatched"/> ' +
((__t = ( _.i18n('attributeMatching.onlyUnmatched', null, 'Only unmatched') )) == null ? '' : __t) +
'</label>\n</div>\n<div class="bulk off">\n    <span><span class="selected-count">0</span> ' +
((__t = ( _.i18n('attributeMatching.selected', null, 'selected') )) == null ? '' : __t) +
' →</span>\n    <input type="text" class="am-ac am-input bulk-value" placeholder="' +
((__t = ( _.i18n('attributeMatching.noMatching', null, '(no matching)') )) == null ? '' : __t) +
'"/>\n    <span class="bulk-label">' +
((__t = ( _.i18n('attributeMatching.applyAs', null, 'Apply as') )) == null ? '' : __t) +
'</span>\n    <span class="bulk-apply" data-target="attr">' +
((__t = ( _.i18n('attributeMatching.shownAs', null, 'Shown as') )) == null ? '' : __t) +
'</span>\n    <span class="bulk-apply" data-target="1">' +
((__t = ( _.i18n('attributeMatching.filter', null, 'Filter') )) == null ? '' : __t) +
' 1</span>\n    <span class="bulk-apply" data-target="2">' +
((__t = ( _.i18n('attributeMatching.filter', null, 'Filter') )) == null ? '' : __t) +
' 2</span>\n    <span class="bulk-apply" data-target="3">' +
((__t = ( _.i18n('attributeMatching.filter', null, 'Filter') )) == null ? '' : __t) +
' 3</span>\n</div>\n<div class="table">\n    <div class="row head">\n        <div class="col-check"><input type="checkbox" class="check-all"/></div>\n        <div class="col-supplier">' +
((__t = ( _.i18n('attributeMatching.supplier', null, 'Supplier / field') )) == null ? '' : __t) +
'</div>\n        <div class="col-label">' +
((__t = ( _.i18n('attributeMatching.supplierValue', null, 'Supplier value') )) == null ? '' : __t) +
'</div>\n        <div class="col-attr" title="' +
((__t = ( _.i18n('attributeMatching.attributeMatches', null, 'Supplier values shown as this value') )) == null ? '' : __t) +
'">' +
((__t = ( _.i18n('attributeMatching.shownAs', null, 'Shown as') )) == null ? '' : __t) +
'</div>\n        <div class="col-filter">' +
((__t = ( _.i18n('attributeMatching.filter', null, 'Filter') )) == null ? '' : __t) +
' 1</div>\n        <div class="col-filter">' +
((__t = ( _.i18n('attributeMatching.filter', null, 'Filter') )) == null ? '' : __t) +
' 2</div>\n        <div class="col-filter">' +
((__t = ( _.i18n('attributeMatching.filter', null, 'Filter') )) == null ? '' : __t) +
' 3</div>\n    </div>\n    <div class="rows"></div>\n</div>\n<div class="am-pager"></div>\n';

}
return __p
};});

